import { RequestStatus } from 'legacy/lut/configs/service'
import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectIsFinancialCockpitLoading = createSelector(
  [selectFinancialCockpitState],
  ({ fetchingStatus }) => fetchingStatus === RequestStatus.PENDING
)
